'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _RuleTypes = require('../constants/RuleTypes');

/* 
Rule:
———
- connectedAccountId: Number
- action: oneOf([“ASSIGN”]) NOTE: This is for futureproofing
- specificTeamMembersAssignment: SpecificTeamMembersAssignment? 
- specificTeamsAssignment: SpecificTeamsAssignment?
- ownerAssignment: OwnerAssignment?

SpecificTeamMembersAssignment
———
- responderIds: [Number]

SpecificTeamsAssignment
———
- assignmentStrategy: oneOf([“ROUND_ROBIN”, “UNASSIGNED”])
- teamIds: [Number]

OwnerAssignment
———
- specificTeamMembersAssignment: SpecificTeamMembersAssignment?
- specificTeamsAssignment: SpecificTeamsAssignment?
*/

exports.default = (0, _immutable.Record)({
  connectedAccountId: null,
  action: _RuleTypes.Actions.ASSIGN,
  specificTeamMembersAssignment: null,
  specificTeamsAssignment: null,
  ownerAssignment: null,
  useInboxAssociatedUsers: false
}, 'Rule');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/Rule.js
// module id = 914
// module chunks = 2 3